import { render, staticRenderFns } from "./confirmationModal.vue?vue&type=template&id=15c256fa&"
import script from "./confirmationModal.vue?vue&type=script&lang=js&"
export * from "./confirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmationModal.vue?vue&type=style&index=0&id=15c256fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports